/* THE MOSSBACK (LS-335, 2026-09-16): a slug the length of a hand, green and pale-striped, that goes to WET ground and dies in the dry -- scorched ground kills it in seconds. Slow, soft, and it leaves a wet trail. Eight frames: a wave travels the length of it.
 * Generated once from a small script and kept as data like every other actor. */

export const mossback_0 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '..oo....oo.oo...',
  '..og...oggo.....',
  '..oGgmgmgmgoo...',
  '..oggGggGggGo...',
  '.k..............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_1 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '..o....ooo.oo...',
  '..oo..oGggo.....',
  '..oGgmgmgmgoo...',
  '..oggGggGggGo...',
  'k.k.............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_2 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '......ooo..oo...',
  '..o..ogGgo..o...',
  '..oogmgmgmgoo...',
  '..oggGggGggGo...',
  '.k..............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_3 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '.....ooo...oo...',
  '....oggGo..oo...',
  '..oogmgmgmggo...',
  '..oggGggGggGo...',
  'k.k.............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_4 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '....ooo....oo...',
  '....Gggo..ogo...',
  '..oogmgmgmggo...',
  '..oggGggGggGo...',
  '.k..............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_5 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '....oo.....oo...',
  '...oGgo...ogo...',
  '..oGgmgmgmggo...',
  '..oggGggGggGo...',
  'k.k.............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_6 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '...oo.....ooo...',
  '..ogGo...oGgo...',
  '..oGgmgmgmggo...',
  '..oggGggGggGo...',
  '.k..............',
  '................',
  '................',
  '................',
  '................',
];

export const mossback_7 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...........e.e..',
  '.............o..',
  '..oo.....oooo...',
  '..ogo...ogGo....',
  '..oGgmgmgmggo...',
  '..oggGggGggGo...',
  'k.k.............',
  '................',
  '................',
  '................',
  '................',
];
